export const instagram = "https://www.instagram.com/fanfarelavenirsaxon/";
export const facebook = "https://www.facebook.com/FanfareAvenirSaxon/";